import { toast, TOAST_TYPE } from '@hivebrite/design-system/Toast';

/**
 * @deprecated please use directly `import { toast } from '@hivebrite/design-system/Toast';` instead
 */
export const displayNotif = (type, message, text) => {
  switch (type) {
    case TOAST_TYPE.SUCCESS:
      toast.success(message, { text });

      break;

    case TOAST_TYPE.ERROR:
      toast.error(message, { text });

      break;

    case TOAST_TYPE.BLANK:
    default:
      toast(message, { text });

      break;
  }
};
